export default async function WebshopDataDeliveryService(hostUrl: string, blockPath: string, webshopPageGuid: string) {
  if (!hostUrl) {
    throw Error("Missing CMS host URL");
  }

  const response = await fetch(hostUrl + `/api/episerver/v3/webshopDataDelivery/` + blockPath, {
    method: "Post",
    body: JSON.stringify({
      "webshopPageGuid": webshopPageGuid,
    }),
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Accept-language": "sv",
    },
  });
  if (!response.ok) {
    throw Error("Failed to fetch content data using webshop data delivery API");
  }
  try {
    const payload = await response.json();
    return payload;
  } catch (error) {
    throw new Error("Failed to parse data");
  }
}
